const telegram = window.Telegram?.WebApp;

export function initTelegram() {
  if (!telegram) return;
  telegram.ready();
  telegram.expand();
  telegram.setHeaderColor('#0b0b0c');
  telegram.setBackgroundColor('#0b0b0c');
  telegram.disableVerticalSwipes?.();
}

function authHeader() {
  if (telegram?.initData) return `tma ${telegram.initData}`;
  return 'dev 184892303';
}

export async function api(path, options = {}) {
  const response = await fetch(path, {
    ...options,
    headers: {
      'content-type': 'application/json',
      authorization: authHeader(),
      ...options.headers
    }
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || 'Не удалось загрузить данные.');
  return payload;
}

export function haptic(type = 'light') {
  telegram?.HapticFeedback?.impactOccurred(type);
}

export function notify(type = 'success') {
  telegram?.HapticFeedback?.notificationOccurred(type);
}

export function openTelegram(username) {
  const clean = String(username || '').replace(/^@/, '');
  if (!clean) return;
  if (telegram?.openTelegramLink) telegram.openTelegramLink(`https://t.me/${clean}`);
  else window.open(`https://t.me/${clean}`, '_blank', 'noopener,noreferrer');
}
